import React, { useEffect, useState, useContext } from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { GiFactory } from 'react-icons/gi'
import { RiPencilRuler2Line } from 'react-icons/ri'
import { useHistory } from 'react-router-dom'
import {  Link } from 'components/common'
import { downloadDocuments } from 'utils/documents'
import { toast } from 'react-toastify'
import { UserContext } from 'stores/UserStore'

const ProductionCard = ({ data }) => {
    const { registryLogOld, registryLog } = useContext(UserContext)

    const { t } = useTranslation()
    const history = useHistory()
    const { idToken } = useContext(UserContext)
    const [selectDetail] = useState('')
    let result = false

    useEffect(() => {
        if (selectDetail === 'purchase') {
            history.push("/purchaseOrder/" + data.detail['purchaseOrder'])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ selectDetail, history])
    

    const downloadReport = (value, type, idToken) => {
        registryLogOld('download_cq' , '/tlh/ippn')
        registryLog('ippn', 'download', 'quality_certificate')
        result = downloadDocuments(value, type, idToken, t)
        if (result) {
            toast(t('tlh.noReport')) 
        }
        
    }

    const content = <>
        <div className="timeline-item-content-base">
            <span className="title-base">
            <GiFactory className="icon-base" />
                {t('tlh.ippn.production.title')}
            </span>
            {data.detail.hasData ?
                <div>
                    <section className="container row">
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.salesOrder')}: </span>
                            <span className="value">
                                <span className="value">{data.detail['salesOrder']}</span>
                            </span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.itemSalesOrder')}: </span>
                            <span className="value">{data.detail['itemSalesOrder']}</span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.cq')}: </span>
                            <span className="value">
                                <Link onClick={() => downloadReport('00' + data.detail['cq'], 'quality-certificate', idToken)}>
                                    {data.detail['cq']}
                                </Link>
                            </span>
                        </div>
                    </section>
                    <span >
                        <RiPencilRuler2Line className="icon-base" />
                        {t('tlh.ippn.production.subtitle')}
                    </span>
                    <section className="container row">
                        
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.od')}: </span>
                            <span className="value">{data.detail['od']}</span>
                            <span className="value">{data.detail['odUnit']}</span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.wt')}: </span>
                            <span className="value">{data.detail['wt']}</span>
                            <span className="value">{data.detail['wtUnit']}</span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.id')}: </span>
                            <span className="value">{data.detail['id']}</span>
                            <span className="value">{data.detail['idUnit']}</span>
                        </div>
                    </section>
                    <section className="container row">
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.linearWeight')}: </span>
                            <span className="value">{data.detail['weight']}</span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.length')}: </span>
                            <span className="value">{data.detail['length']}</span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.grade')}: </span>
                            <span className="value">{data.detail['grade']}</span>
                            <span className="value">{data.detail['gradeUnit']}</span>
                        </div>
                    </section>
                    <section className="container row">
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.drift')}: </span>
                            <span className="value">{data.detail['drift']}</span>
                            <span className="value">{data.detail['driftUnit']}</span>
                        </div>
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.connection')}: </span>
                            <span className="value">{data.detail['connection']}</span>
                        </div>
                        {
                            data.detail['connectionii'] ?
                                <div className="item">
                                    <span className="label">{t('tlh.ippn.production.connection')}: </span>
                                    <span className="value">{data.detail['connectionii']}</span>
                                </div>
                                :
                                null
                        }
                        <div className="item">
                            <span className="label">{t('tlh.ippn.production.range')}: </span>
                            <span className="value">{data.detail['range']}</span>
                        </div>
                    </section>
                </div>
                :
                <div className="noData">{t('tlh.ippn.production.noData')}</div>
            }
        </div>
    </>
    return content 
}

export default ProductionCard
